<template lang="html">
  <div>
    <v-card>
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group>
            <v-row no-gutters>
              <v-col
                v-for="(form, index) in forms"
                :key="index"
                cols="12"
                md="6"
                lg="4"
              >
                <v-list-item
                  :to="'/researchers/' + investigator.person.id + form.path"
                  class="text-left"
                >
                  <v-list-item-icon>
                    <v-icon v-text="form.icon"></v-icon>
                  </v-list-item-icon>
                  {{ $t(form.title) }}
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-card class="mt-4">
      <v-tabs v-model="tab">
        <v-tab v-for="item in items" :key="item.tab">
          {{ $t(item.tab) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item.tab" class="px-6 pb-6">
          <component
                  v-if="item.person !== undefined"
                  :is="item.content"
                  :person="item.person"
                  class="mt-5"
          />
          <component v-else :is="item.content" />
        </v-tab-item>
      </v-tabs-items>

      <v-row>
        <v-col class="text-center my-6">
          <v-btn
                  type="submit"
                  class="btn-large-space btn-danger mr-4"
                  text
                  v-on:click="$router.go(-1)"
          >{{ $t("button.back") }}</v-btn
          >
          <DeleteReasonBtn
                  url-objects="person"
                  object_type="investigator"
                  :headers="headers"
                  :item="investigator.person"
          />
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-6 text-center">

    </div>
  </div>
</template>

<script type="text/javascript">
import axios from "axios";
import DeleteReasonBtn from "../delete_object/DeleteObjectForm";
import PersonalData from "../users/PersonalData";
import AccountVinculationWorkplaceData from "../users/AccountVinculationWorkplaceData";
export default {
  components: { DeleteReasonBtn, PersonalData, AccountVinculationWorkplaceData },
  data() {
    return {
      investigator: {
        person: {
          preferred_name: "",
          alt_name: "",
          email: [],
          id_number: "",
          number: ""
        },
        account: {}
      },
      forms: [
        {
          icon: "mdi-calendar-arrow-right",
          title: "investigator.forms.modifyVinculation",
          path: "/forms/modifyVinculationForm"
        },
        {
          icon: "mdi-calendar-plus",
          title: "investigator.forms.newVinculation",
          path: "/forms/vinculationForm"
        },
        {
          icon: "mdi-account-arrow-right",
          title: "investigator.forms.modifyExtendAccount",
          path: "/forms/modifyExpirationDateForm"
        },
        {
          icon: "mdi-office-building-marker",
          title: "investigator.forms.modifyWorkplaceAssignattion",
          path: "/forms/workplaceAssignationForm"
        },
        {
          icon: "mdi-office-building",
          title: "investigator.forms.modifyWorkplace",
          path: "/forms/modifyWorkplaceForm"
        },
        {
          icon: "mdi-baby-face-outline",
          title: "investigator.forms.modifyBasicData",
          path: "/forms/personalForm"
        },
        {
          icon: "mdi-police-badge",
          title: "investigator.forms.modifyResponsible",
          path: "/forms/modifyResponsibleForm"
        },
        {
          icon: "mdi-server",
          title: "investigator.forms.modifyServices",
          path: "/forms/modifyServicesForm"
        },
        {
          icon: "mdi-teach",
          title: "investigator.forms.affiliationForm",
          path: "/forms/affiliationForm"
        }
      ],
      tab: null,
      items: [
        {
          tab: "account.personal.data",
          content: "PersonalData",
          person: parseInt(this.$route.params.id)
        },
        {
          tab: "account.status",
          content: "AccountVinculationWorkplaceData",
          person: parseInt(this.$route.params.id)
        }
      ]
    };
  },

  methods: {
    getInvestigator() {
      const path =
        this.$store.state.endpoint + "/person/" + this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.investigator.person = response.data;
        })
        .finally(this.setBreadcrumb)
        .catch(error => {
          console.log(error);
        });
    },
    getAccount() {
      const path =
        this.$store.state.endpoint + "/account/" + this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.investigator.account = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    setBreadcrumb(){
      const text = this.investigator.person.preferred_name.given_name + ' ' + this.investigator.person.preferred_name.family_name
      let item = {
        text: text,
        disabled: true,
        last: true
      };
      if (!this.$route.meta.breadCrumb.some(breadcrumb => { return breadcrumb.last === true})) {
        this.$route.meta.breadCrumb.push(item);
      } else {
        this.$route.meta.breadCrumb.pop();
        this.$route.meta.breadCrumb.push(item);
      }
      this.$store.state.sectionTitle = text;
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("name"),
          value: "preferred_name.given_name",
          width: "15%"
        }
      ];
    }
  },

  created() {
    this.getInvestigator();
    this.getAccount();
  }
};
</script>
